import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from '@osmosis/react-ui/components/Button';
import { useColors } from '@osmosis/react-ui/hooks/useColors';
import { Flex, Image } from 'rebass';
import { P } from '@osmosis/react-ui/components/Text';
import { lighten } from '@osmosis/shared/styles/colorModifiers';
import router from 'next/router';
import { useUserContext } from '@osmosis/nextjs-components/context/UserContext';

/**
 *ExpiredDealBanner.
 */
const ExpiredDealBannerContent: React.FC = (): JSX.Element => {
  const colors = useColors();
  const { getPlansUrl } = useUserContext();
  const handleClick = () => {
    router.push(getPlansUrl('?source_cta=deal-expired'));
  };
  return (
    <Flex flexDirection="column" alignItems="center">
      <Flex flex={1} justifyContent="center" margin="40px 0">
        <Image
          src="https://d3cdo0emj8d2qc.cloudfront.net/assets/qymdjfYmSOeKh3vX5Td5QlWKRJqUCC10.png"
          alt="Expired deal"
          sx={{
            width: '50%',
          }}
        />
      </Flex>
      <P color={colors.black} fontSize="16px" marginBottom={15}>
        <FormattedMessage
          id="plans.expired.deal.banner.content.title"
          defaultMessage="Check out our plans and join Osmosis Plan today!"
        />
      </P>
      <Button
        fontSize="16px"
        frameBorder="3px"
        marginBottom={25}
        onClick={handleClick}
        data-testid="deal-banner-see-plans-btn"
        color={colors.teal}
        backgroundColor={colors.white}
        margin="auto"
        sx={{
          border: 'solid 2px',
          borderColor: colors.teal,
          borderRadius: 100,
          transition: 'background 0.2s ease-in-out',
          ':hover': {
            background: lighten(0.5, colors.teal),
          },
          ':active': {
            background: lighten(0.4, colors.teal),
          },
        }}
      >
        <FormattedMessage
          id="plans.expired.deal.banner.content.button"
          defaultMessage="See plans"
        />
      </Button>
      <P
        color={colors.black}
        fontSize="16px"
        maxWidth={550}
        marginBottom={100}
        textAlign="center"
      >
        <FormattedMessage
          id="plans.expired.deal.banner.content.description"
          defaultMessage="If you were directed to this Osmosis discount by an instructor at your school, please contact them for further details."
        />
      </P>
    </Flex>
  );
};
export default ExpiredDealBannerContent;
